import "./services.css";

import React from "react";

import { SERVICES } from "../../data/content";
import { SECTIONS } from "../../utils/stateTypes";
import SectionHeading from "../general/SectionHeading";
import ConveyancingSteps from "./ConveyancingSteps";

//House icon from the original site
const HouseIcon = () => (
  <svg
    viewBox={"9.876 43.4 179.909 113"}
    xmlns={"http://www.w3.org/2000/svg"}
    aria-hidden={"true"}
    className={"service-icon"}
  >
    <path
      fill={"currentColor"}
      d={"M100.2 67.5c-5 0-9 4.1-9 9.1s4.1 9.1 9 9.1 9-4.1 9-9.1c.1-5-4-9.1-9-9.1zm0 14.1c-2.7 0-5-2.2-5-5s2.3-5.1 5-5.1 5 2.2 5 5.1c0 2.9-2.3 5-5 5z"}
    />
    <path
      fill={"currentColor"}
      d={"M80.3 59.6L65.2 74.8c-1.6 1.7-2.7 6.4-2.7 6.4H44.1c-3 0-6.1 1.4-8 3.5l-24.8 27.9c-1.1 1.1-1.9 2.7-1.1 4.2.6 1.1 2.4.9 3.9.9H19v33.6c0 2.8 2.3 5.1 5.1 5.1h151.2c2.8 0 5.4-1.6 5.4-4.4v-34.1h5c1.4 0 3-.5 3.8-2 .7-1.4 0-3.2-.9-4.2l-24.8-28c-2.1-2.2-5.2-2.6-8.2-2.6H138s-1.1-4.7-2.7-6.3l-28.4-28.7c-1.8-1.8-3.9-2.7-6.3-2.7-2.3 0-5 .9-6.9 2.7m-79.1 68.3L38.8 87c.9-.9 3.8-2.2 5.2-2.2h27.4v29.6H14.6zM71.5 149c.2 1.2.5 2.2 1.1 3H25.3c-1.7-.1-1.7-.8-1.7-1.7v-32.4h47.8v29.9m37.9 4.2H92.2v-30.5h15.6V152h1.5zm11.4.1H112V120c0-1.1-.9-2-2-2H89.7c-1.1 0-2 .9-2 2v32h-7.4c-.9 0-1.8-.3-2.5-.7-.2-.2-.4-.3-.6-.6-.7-.7-1.2-1.8-1.2-3v-66c0-.9.3-1.8.9-2.6l11.4-11.4 2.2-2.4c.2-.2.3-.2.3-.3l7.5-7.5c.7-.7 1.5-1.1 2.4-1.1s1.8.3 2.5 1.1l21.3 21.6c.6.7 1.1 1.7 1.1 2.6v65.7c0 2.2-2.6 4.7-4.9 4.7zM83.2 62.3l3.1-3.1c.2-.2.3-.2.3-.3l9.9-10c1.1-1.1 2.9-1.5 4.2-1.5 1.4 0 3.1.5 4.2 1.5l27.6 28.6c.9.9 1.4 2.2 1.5 3.6h-4.9c-.3-2-.9-3.4-2.1-4.7l-21.4-21.7c-1.5-1.5-3-2.3-5-2.3s-4.2.7-5.7 2.3l-7.5 7.6-2.4 2.8-11.6 11.3c-1.2 1.2-1.8 3.6-2 4.8h-5c.2-.6.6-2.8 1.5-3.7m61.3 40.4H177V150c0 1.4-1.9 2-1.9 2h-47.2s1.3-1.7 1.3-4.4v1.4m49.6-34.7l-49.6-.1V84.8h27.3c2.9 0 4.1 1.3 5.1 2.2l.2.2 24.1 27.3h-7.1v-.2z"}
    />
  </svg>
);

const Services = () => {
  return (
    <section
      id={SECTIONS.SERVICES}
      className={"section services"}
    >
      <div className={"container"}>
        <SectionHeading
          tag={SERVICES.tag}
          title={SERVICES.title}
        />

        <div className={"service-list"}>
          {SERVICES.items.map((item) => (
            <div
              key={item.title}
              className={"service-item"}
            >
              <HouseIcon />
              <h3 className={"service-title"}>{item.title}</h3>
              <p className={"service-text"}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <ConveyancingSteps />
    </section>
  );
};

export default Services;
